document.addEventListener('DOMContentLoaded', () => {
  const CLICK_IDS = ['fbclid', 'gclid', 'ttclid', 'msclkid'];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const canObserve = 'IntersectionObserver' in window;
  const saveData = navigator.connection?.saveData ?? false;
  const incoming = new URLSearchParams(window.location.search);

  const initReveal = (root) => {
    if (!canObserve || reducedMotion.matches) return;

    root.classList.add('is-reveal-ready');
    const observer = new IntersectionObserver((entries) => {
      for (const { isIntersecting, target } of entries) {
        if (!isIntersecting) continue;
        target.classList.add('is-visible');
        observer.unobserve(target);
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -10px 0px' });

    for (const item of root.querySelectorAll('[data-ppa-reveal]')) observer.observe(item);
  };

  const forwardAttribution = (root) => {
    for (const link of root.querySelectorAll('[data-ppa-product-link]')) {
      const destination = new URL(link.href, window.location.origin);
      for (const [key, value] of incoming) {
        if (/^utm_/i.test(key) || CLICK_IDS.includes(key)) destination.searchParams.set(key, value);
      }
      link.href = destination.toString();
    }
  };

  const initVideo = (video) => {
    video.addEventListener('play', () => {
      document.dispatchEvent(new CustomEvent('theme:video:playing', { detail: { video } }));
    });

    document.addEventListener('theme:video:playing', ({ detail }) => {
      if (detail.video !== video) video.pause();
    });

    if (!canObserve) return;

    new IntersectionObserver((entries) => {
      for (const { isIntersecting } of entries) {
        if (isIntersecting && !reducedMotion.matches && !saveData) video.play().catch(() => {});
        else if (!isIntersecting) video.pause();
      }
    }, { threshold: 0.4 }).observe(video);
  };

  for (const root of document.querySelectorAll('[data-ppa-solution]')) {
    initReveal(root);
    forwardAttribution(root);
    for (const video of root.querySelectorAll('[data-ppa-autoplay]')) initVideo(video);
  }
});
